/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Modular_Wizard_Relay_CloudInputs */



/**
* | output |
* | --- |
* | "oneAI Cloud (no relay)" |
*
* @param {Spaces_Modular_Wizard_Relay_CloudInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_modular_wizard_relay_cloud = /** @type {((inputs?: Spaces_Modular_Wizard_Relay_CloudInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Modular_Wizard_Relay_CloudInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("oneAI Cloud (kein Relay)")
	return /** @type {LocalizedString} */ ("oneAI Cloud (no relay)")
});